import { useEffect, useRef, useState } from 'react';
import { Whisper, Tooltip } from 'rsuite';
import { copyToClipboard } from '@utils/helpers';
import { icons } from '@shared/static/icons';
import { useTranslation } from 'react-i18next';

export function CopyToClipWhisper({
  value,
  children,
  display,
  classes,
  fetchValue,
}) {
  const whisperRef = useRef();
  const timerRef = useRef(null);
  const { t } = useTranslation();
  const [isCopied, setIsCopied] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);

  useEffect(() => () => clearTimeout(timerRef.current), []);

  let tooltipMessage = t('copied_to_clipboard');
  if (isLoading) tooltipMessage = t('loading');
  else if (isError) tooltipMessage = t('data_fetch_error');

  function hideTooltip(delay, reset) {
    timerRef.current = setTimeout(() => {
      reset();
      whisperRef.current?.close();
    }, delay);
  }

  async function handleClick(e) {
    e.stopPropagation();
    clearTimeout(timerRef.current);
    let copyValue = value;
    if (fetchValue) {
      setIsLoading(true);
      whisperRef.current?.open();
      try {
        copyValue = await fetchValue();
      } catch {
        setIsLoading(false);
        setIsError(true);
        hideTooltip(1500, () => setIsError(false));
        return;
      }
      setIsLoading(false);
    }
    setIsError(false);
    copyToClipboard(copyValue);
    setIsCopied(true);
    whisperRef.current?.open();
    hideTooltip(1000, () => setIsCopied(false));
  }

  return (
    <Whisper
      placement="top"
      trigger="none"
      speaker={<Tooltip>{tooltipMessage}</Tooltip>}
      ref={whisperRef}
    >
      <button
        className={['dashed-btn', classes, isCopied && 'copied']
          .filter(Boolean)
          .join(' ')}
        type="button"
        disabled={isLoading}
        onClick={handleClick}
      >
        {icons.copy}
        {display}
        {children}
      </button>
    </Whisper>
  );
}
